import USMLEStudyPlan from './USMLEStudyPlan';
function App() { return <USMLEStudyPlan />; }
export default App;